// :cow: Cosmose CONFIDENTIAL :iso:
export enum PlannerType {
  AudienceCriteria = 'audience',
  TargetGroupSpecification = 'groups',
  Timeline = 'timeline',
  Budget = 'budget',
  Media = 'media',
  Start = '',
}
